export default __webpack_public_path__ + "images/erickson-living-knockout.svg?063b7f807c07cc0949814434f2d117c8";